export default {"src":"/_next/static/media/acornsquash.0086dede.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};